import { runtimeEnv } from 'config/runtimeEnv';
import { API_ENDPOINT } from './Api';
import requestInstance from './Request';
import { setCurrentUser } from '../utils/utils';

let env = runtimeEnv('B2B_API_BASE_URL');

export const carApi = async (payload) => {
  let url;
  if (payload?.type) {
    url = `${env}${API_ENDPOINT.Car.companyCarApi}?type=${payload?.type}&contractId=${payload?.contractId}&location=${payload?.location}`;
  } else {
    url = `${env}${API_ENDPOINT.Car.api}`;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};
export const addCarApi = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.Car.api}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};
export const updateCarApi = async (data) => {
  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.Car.api + '/' + data.get('carId')}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};
export const deleteCarApi = async (data) => {
  const res = await requestInstance
    .delete(`${env}${API_ENDPOINT.Car.api + '/' + data.carId}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};
export const carFacilities = async (data) => {
  let url = `${env}${API_ENDPOINT.Car.facilitiesApi + '/' + data}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const facilitiesApi = async (id) => {
  let url = `${env}${API_ENDPOINT.Car.facilities}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};
